import { render, staticRenderFns } from "./Costos.vue?vue&type=template&id=593885e1&"
import script from "./Costos.vue?vue&type=script&lang=js&"
export * from "./Costos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports